import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=62cf548a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=62cf548a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cf548a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62cf548a')) {
      api.createRecord('62cf548a', component.options)
    } else {
      api.reload('62cf548a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=62cf548a&scoped=true&", function () {
      api.rerender('62cf548a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rYuE96YCDUxt/JS/comp/GuestBox.vue"
export default component.exports